export function createNewRow<T>(): T {
  return {} as T;
}
